import { ModelHunk } from "./Core/ModelStoring/ModelHunk";

export function fixInnerTypesFromCandyBackend(modelHunk: ModelHunk): void {
    for (const path of modelHunk.iteratePaths()) {
        const viewModel = modelHunk.get(path);
        if (viewModel != undefined) {
            if (viewModel.value != undefined && typeof viewModel.value === "boolean") {
                modelHunk.updateIfExists(path, x => (x.value = x.value?.toString()));
            }
        }
    }
}
